import React, { useEffect, useState } from 'react';
import { Tool, useAppDate } from '../context/AppContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUserValidation } from '../hooks/useUserValidation';

const InitalInfor: React.FC = () => {
  const { jointToChatRoom, clearData, setTool, tool } = useAppDate();
  const { isValideUser, login,  error, setError } = useUserValidation();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);  

  const navigate = useNavigate();

  const handleJoin = () => {
    if (email.trim()) {
      login(email, password, tool as Tool)
        .then(res => {
          if (res?.token) {                  
            sessionStorage.setItem('userToken', String(res.token));            
            jointToChatRoom({ userEmail: email, role: 'user', tool: tool as Tool, name: name });
            navigate('/user-chat')
          }else{
            setError('Invalid user');
          }
        }).catch(err => {
          setError(err);
        })
    }
  };

  useEffect(() => {
    const tool = searchParams.get('tool');
    const email = searchParams.get('email');
    if (email) {
      setLoading(true);
      isValideUser(email, tool as Tool)
        .then(isValid => {
          if (isValid) {
            setEmail(email);
          }
          setLoading(false);
        }).catch(err => {
          setLoading(false);
        })
    }
    if (tool) {
      setTool(tool as Tool);
    } else {
      setTool(Tool.ETF); // Default tool if not specified
    }
  }, [searchParams]);

  useEffect(() => {
    clearData();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-sm">
        <h1 className="text-2xl font-bold mb-4">Join {tool?.toUpperCase()} Chat Room</h1>
        <input
          type="text"
          disabled={loading}
          className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring"
          placeholder="Enter your first name and last name"
          value={name}
          onChange={e => {
            setName(e.target.value);
            setError(null);
          }}
        />
        <input
          type="email"
          disabled={loading}
          className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring"
          placeholder={tool===Tool.ETF ? "Enter your email (ETF)" : "Enter your username(SCC)"}
          value={email}
          onChange={e => {
            setEmail(e.target.value);
            setError(null);
          }}
        />
        <div className="relative mb-4">
          <input
            type={showPassword ? "text" : "password"}
            disabled={loading}
            className="w-full border rounded px-3 py-2 pr-10 focus:outline-none focus:ring"
            placeholder={`Enter your password to ${tool === 'ETF' ? '(ETF)' : ''}`}
            value={password}
            onChange={e => {
              setPassword(e.target.value);
              setError(null);
            }}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L8.464 8.464m1.414 1.414L16.95 16.95M9.878 9.878a3 3 0 113.002-2.659m-.005 4.901A3 3 0 0116.95 16.95" />
              </svg>
            ) : (
              <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            )}
          </button>
        </div>
        <button
          className={`w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition ${
            (!email.trim() || loading || error !== null) ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
          onClick={handleJoin}
          disabled={!email.trim() || loading || error !== null}
        >
          Join
        </button>

        { error && (
          <div className="mt-4 text-red-500">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default InitalInfor;

